import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);
export const selectCreateLoading = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsCreate.loading,
);
